// Social media URLs configuration
export const socialLinks = {
    facebook: 'https://www.facebook.com/share/19i2p1Ab8M/?mibextid=wwXIfr',
    instagram: '#',
    youtube: 'https://www.youtube.com/channel/UCMX4ihrgy1w84UTCzJ93jng',
    tiktok: '#'
};
